import React, { useMemo } from 'react'
import useTranslation from 'next-translate/useTranslation'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useSession from 'tennders-auth/hooks/useSession'
import { STATUS_CANCELLED } from 'tennders-stracture/libs/constants'
import useTransactionComments from 'tennders-transactions/hooks/useTransactionComments'
import DetailHistory from './History'
import { CommentBox } from './CommentBox'

const DetailLog = () => {
  const { t } = useTranslation()
  const { transaction } = useTransaction()
  const { postComment } = useTransactionComments()
  const { isShipperUser, isCarrierUser, isBrokerUser } = useSession()

  const shouldShowCommentsOnly = useMemo(() => !isBrokerUser, [isBrokerUser])

  const isLoadVisible = useMemo(() => (
    transaction?.loadVisible && !transaction?.matchedLoad?.isMarketPlaced
  ), [transaction?.loadVisible, transaction?.matchedLoad?.isMarketPlaced])

  const isTruckVisible = useMemo(() => (
    transaction?.truckVisible && !transaction?.matchedTruck?.isMarketPlaced
  ), [transaction?.truckVisible, transaction?.matchedTruck?.isMarketPlaced])

  const isBothVisible = useMemo(() => isLoadVisible && isTruckVisible, [isLoadVisible, isTruckVisible])

  if (!transaction.isMatched && !transaction.isBooked && transaction?.status?.label !== STATUS_CANCELLED) {
    return null
  }

  return (
    <>
      {!transaction?.isCancelled && (isLoadVisible || isTruckVisible) && (
        <>
          <div className="hr" />
          <h3 className="pb-8 mt-10 mb-0 lh-1">{t('transaction:' + (isShipperUser || isCarrierUser ? 'public_comments' : 'comments'))}</h3>
          <div className="d-flex row mb-32">
            {isLoadVisible ? (
              <CommentBox
                isBothVisible={isBothVisible}
                params={{ load: transaction?.matchedLoad?.id }}
                postComment={postComment}
              />
            ) : null}
            {isTruckVisible ? (
              <CommentBox
                isBothVisible={isBothVisible}
                params={{ truck: transaction?.matchedTruck?.id }}
                postComment={postComment}
              />
            ) : null}
          </div>
        </>
      )}
      {(isLoadVisible || isTruckVisible) && (
        <>
          <h3 className="pb-8 mb-0 lh-1">{t('transaction:transactionHistory')}</h3>
          <div className="d-flex row mb-32">
            <DetailHistory transaction={transaction} shouldShowCommentsOnly={shouldShowCommentsOnly} />
          </div>
        </>
      )}
    </>
  )
}

export default DetailLog
